/*
  브라우저에 직접 webp를 그려본 뒤 webp 지원여부를 판단합니다.
  Global kakaopage 코드를 참고했습니다. Link: https://github.kakaocorp.com/kakaopage/pageweb-global/blob/master/src/viewer/decrypt.ts#L84
  ios14에서 webp를 지원하지만 애니메이션이 부자연스러운 이슈가 있어서 ios는 무조건 webp 지원에서 제외합니다. https://podotree.atlassian.net/browse/KW-2051
*/
export async function getIsSupportWebp(isIos: boolean): Promise<boolean> {
  if (isIos) {
    return false;
  }
  return new Promise(resolve => {
    const image = new Image();
    function testWebp(e: Event | string) {
      // 아래 로직은 Modernizr 참고함
      // https://github.com/Modernizr/Modernizr/blob/400db4043c22af98d46e1d2b9cbc5cb062791192/feature-detects/img/webp.js
      // 1x1사이즈 webp 이미지를 로드 했을 때 webp를 지원하지 않으면 image 사이즈가 0x0이므로 webp지원여부를 판단할 수 있다.
      const result =
        typeof e === 'object' && e.type === 'load' ? image.width === 1 : false;
      resolve(result);
    }
    image.onerror = testWebp;
    image.onload = testWebp;
    image.src =
      'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
  });
}
